/**
 * @generated SignedSource<<034a981e34fe29853113d91734d4c020>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type WebFormQuestionTypeTableFieldFragment$data = {
  readonly options: ReadonlyArray<{
    readonly id: string;
    readonly label: string;
  }> | null;
  readonly richEditorBody: string;
  readonly type: WebFormQuestionType;
  readonly " $fragmentType": "WebFormQuestionTypeTableFieldFragment";
};
export type WebFormQuestionTypeTableFieldFragment$key = {
  readonly " $data"?: WebFormQuestionTypeTableFieldFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WebFormQuestionTypeTableFieldFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WebFormQuestionTypeTableFieldFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "richEditorBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormQuestionOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WebFormQuestion",
  "abstractKey": null
};

(node as any).hash = "5bf09b1ab5afe83bcea72e5d63ccb28a";

export default node;
